
import CheckBoxPlugin from './CheckBoxPlugin';
import RadioButtonPlugin from './RadioButtonPlugin';
import ArrowDownPlugin from './ArrowDownPlugin';
import RadioButtonPfPlugin from './RadioButtonPfPlugin';
import SearchRedPfPlugin from './SearchRedPfPlugin';
import ClearRedPfPlugin from './ClearRedPfPlugin';
import SortUpRedPlugin from './SortUpRedPlugin';
import ClearRedPlugin from './ClearRedPlugin';
import MenuIconPlugin from "./MenuIconPlugin";

const SvgPlugin = {};

SvgPlugin.install = function(Vue, options) {
    Vue.CheckBox = CheckBoxPlugin;
    Vue.RadioButton = RadioButtonPlugin;
    Vue.ArrowDown = ArrowDownPlugin;
    Vue.RadioButtonPf = RadioButtonPfPlugin;
    Vue.SearchRedPf = SearchRedPfPlugin;
    Vue.ClearRedPf = ClearRedPfPlugin;
    Vue.SortUpRed = SortUpRedPlugin;
    Vue.ClearRed = ClearRedPlugin;
    Vue.MenuIcon = MenuIconPlugin;

}; // install

export default SvgPlugin;



// WEBPACK FOOTER //
// ./src/common/plugins/svg/SvgPlugin.js